import { ParentFromServerType } from "../models/state/Parent";
import { actions } from "../reduxBundle";

export function receiveParents({
  parents
}: {
  parents: ParentFromServerType[];
}) {
  return actions.receiveMany(parents);
}

export function receiveParent({ parent }: { parent: ParentFromServerType }) {
  return actions.receiveOne(parent);
}

export function deleteParent(parentId: string) {
  return actions.delete(parentId);
}
